import { useEffect, useState } from 'react'
import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'

import { SecondaryBase } from './../Commons/SecondaryBase'
import { Confirm } from './../../Commons/Modals/Confirm'

import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones'
import { 
    PrepareMachine as BLPrepareMachine, 
    SpinMachine as BLSpinMachine,
    ToggleQR as BLToggleQR,
    ToggleThanks as BLToggleThanks,
    EnterMachine as BLEnterMachine,
    GetMachineConfig as BLGetMachineConfig,
    SaveMachineConfig as BLSaveMachineConfig,
    GetActiveScreens as BLGetActiveScreens,
    CreateMachineScreen as BLCreateMachineScreen,
    DeleteMachineScreen as BLDeleteMachineScreen,
    IdentifyAllScreens as BLIdentifyAllScreens
} from './../../../utilities/BL/SlotMachine'

import { PremiumQR } from './../../Commons/PremiumQR'


const SlotMachine = ({ getOutOfTheDynamic }) => {
    const { showMessage } = useFloatMessage();
    const [isLoading, setIsLoading] = useState(false);
    const [lastRefresh, setLastRefresh] = useState('');

    const [screensList, setScreensList] = useState([]);
    
    // Control de Acordeones
    const [isMainExpanded, setIsMainExpanded] = useState(true);
    const [isStandsExpanded, setIsStandsExpanded] = useState(false);

    // Modales
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({ message: '', action: null, textYes: '', textNo: 'Cancelar' });
    const [showQRModal, setShowQRModal] = useState(false);
    const [qrTargetUrl, setQrTargetUrl] = useState('');
    const [tvTargetUrl, setTvTargetUrl] = useState('');
    const [qrTitle, setQrTitle] = useState('');

    // Estado: Memoria independiente para los botones de Agradecimiento
    const [thanksStates, setThanksStates] = useState({});

    // Configuración Estadio (ID 1 Fijo)
    const [mainConfig, setMainConfig] = useState({ targetScreenId: 1, winProbability: 30, baseTimeMs: 2200, celebrationTimeMs: 6000, scale: 100 });
    const [showCustomMainProb, setShowCustomMainProb] = useState(false);
    const [showCustomMainTimes, setShowCustomMainTimes] = useState(false);

    // Configuración Stands (ID > 1)
    const [selectedStandId, setSelectedStandId] = useState(0);
    const [standConfig, setStandConfig] = useState({ targetScreenId: 0, winProbability: 30, baseTimeMs: 2200, celebrationTimeMs: 6000, scale: 100 });
    const [showCustomStandProb, setShowCustomStandProb] = useState(false);
    const [showCustomStandTimes, setShowCustomStandTimes] = useState(false);

    const [tempInputs, setTempInputs] = useState({});

    useEffect(() => {
        loadScreensData();
    }, []);

    // const loadScreensData = async () => {
    //     const result = await BLGetActiveScreens();
    //     if (result.success && result.data) {
    //         setScreensList(result.data);
            
    //         const mainResult = await BLGetMachineConfig(1);
    //         if (mainResult.success && mainResult.data) setMainConfig({ ...mainResult.data, scale: mainResult.data.scale || 100 });

    //         const stands = result.data.filter(s => s.id !== 1);
    //         if (stands.length > 0) {
    //             // Si el stand seleccionado actual fue borrado o no existe, selecciona el primero
    //             if (!stands.find(s => s.id === selectedStandId)) {
    //                 setSelectedStandId(stands[0].id);
    //                 loadConfigForStand(stands[0].id);
    //             }
    //         } else {
    //             setSelectedStandId(0);
    //         }
    //     }
    // };

    const loadScreensData = async () => {
        const result = await BLGetActiveScreens();
        if (result.success && result.data) {
            setScreensList(result.data);
            
            const mainResult = await BLGetMachineConfig(1);
            if (mainResult.success && mainResult.data) setMainConfig({ ...mainResult.data, scale: mainResult.data.scale || 100 });

            const stands = result.data.filter(s => s.id !== 1);
            if (stands.length > 0) {
                if (!stands.find(s => s.id === selectedStandId)) {
                    setSelectedStandId(stands[0].id);
                    loadConfigForStand(stands[0].id);
                }
            } else {
                setSelectedStandId(0);
            }
        }
        // Guardamos la hora de la consulta
        setLastRefresh(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    };

    const loadConfigForStand = async (standId) => {
        if (!standId || standId === 0) return;
        const result = await BLGetMachineConfig(standId);
        if (result.success && result.data) {
            setStandConfig({ ...result.data, scale: result.data.scale || 100 });
        }
    };

    const handleStandChange = (e) => {
        const id = Number(e.target.value);
        setSelectedStandId(id);
        loadConfigForStand(id);
    };

    // ==========================================
    // AUTO-GUARDADO
    // ==========================================
    const autoSaveConfig = async (newConfig) => {
        showMessage('Enviando...', MESSAGE_TYPE.INFO);
        const result = await BLSaveMachineConfig(newConfig);
        if(result.success) {
            showMessage('✅ Reglas actualizadas', MESSAGE_TYPE.SUCCESS);
        } else {
            showMessage('Error al guardar', MESSAGE_TYPE.ERROR);
        }
    };

    const updateMainConfig = (field, value) => {
        const updated = { ...mainConfig, [field]: value };
        setMainConfig(updated);
        autoSaveConfig(updated);
    };

    const updateStandConfig = (field, value) => {
        if(selectedStandId === 0) return;
        const updated = { ...standConfig, [field]: value };
        setStandConfig(updated);
        autoSaveConfig(updated);
    };

    const handleTempInputChange = (key, value) => setTempInputs(prev => ({ ...prev, [key]: value }));
    const applyCustomValue = (isMain, field, key) => {
        const val = Number(tempInputs[key]);
        if (!isNaN(val)) {
            if (isMain) updateMainConfig(field, val);
            else updateStandConfig(field, val);
        }
    };
    const handleKeyDown = (e, isMain, field, key) => { if (e.key === 'Enter') applyCustomValue(isMain, field, key); };

    // ==========================================
    // ACCIONES DE PANTALLAS
    // ==========================================
    const handleAddScreen = async () => {
        const screenName = window.prompt("Escribe el nombre de la nueva pantalla (Ej: Stand VIP, Entrada Norte):");
        if (!screenName || screenName.trim() === '') return;
        setIsLoading(true);
        showMessage('Creando pantalla...', MESSAGE_TYPE.INFO);
        
        const result = await BLCreateMachineScreen(screenName.trim());
        if (result.success) {
            const newScreenId = result.data.id;
            
            const inheritedSymbols = (mainConfig.symbols && mainConfig.symbols.length > 0) 
                ? mainConfig.symbols 
                : ['1.png','2.png','20.png','21.png','22.png','23.png','24.png','25.png','26.png','27.png','28.png','29.png','30.png','31.png','32.png','33.png','34.png','35.png','36.png','37.png','38.png','39.png','40.png','41.png','42.png']; // Varonil
                //: ['1.png','6.png','7.png','8.png','9.png','10.png','11.png','12.png','13.png','14.png','15.png','16.png','17.png','18.png','19.png']; // Femenil
                //: ['1.png', '2.png', '3.png', '4.png', '5.png'];

            await BLSaveMachineConfig({
                targetScreenId: newScreenId,
                winProbability: 30, 
                baseTimeMs: 2200,
                celebrationTimeMs: 6000,
                scale: 100,
                symbols: inheritedSymbols 
            });

            showMessage(`¡Pantalla "${screenName}" creada! Mostrando enlaces...`, MESSAGE_TYPE.SUCCESS);
            await loadScreensData();
            setIsStandsExpanded(true);
            setSelectedStandId(newScreenId);
            loadConfigForStand(newScreenId);
            openQRModal(newScreenId, result.data.connectionToken, result.data.name);
        } else {
            showMessage(result.message, MESSAGE_TYPE.ERROR);
        }
        setIsLoading(false);
    };

    const confirmDeleteScreen = () => {
        const stand = screensList.find(s => s.id === selectedStandId);
        setConfirmConfig({
            message: `¿Estás seguro de eliminar el "${stand?.name}"? Esta acción desconectará la pantalla.`,
            action: async () => {
                showMessage('Eliminando...', MESSAGE_TYPE.INFO);
                const res = await BLDeleteMachineScreen(selectedStandId);
                if(res.success){
                    showMessage('Pantalla eliminada', MESSAGE_TYPE.SUCCESS);
                    loadScreensData();
                } else showMessage(res.message, MESSAGE_TYPE.ERROR);
                return res;
            },
            textYes: 'Sí, Eliminar',
            textNo: 'Cancelar'
        });
        setShowConfirmModal(true);
    };

    const openQRModal = (screenId, token, name) => {
        const tvUrl = (screenId === 1 || screenId === 0) 
            ? `${window.location.origin}/screen` 
            : `${window.location.origin}/pantalla-stand/${screenId}`;
        setTvTargetUrl(tvUrl);

        const finalScreenId = screenId === 0 ? 1 : screenId;
        const playerUrl = `${window.location.origin}/slot?screenId=${finalScreenId}`;
        setQrTargetUrl(playerUrl);

        setQrTitle(`Unirse a: ${name}`);
        setShowQRModal(true);
    };

    // ==========================================
    // ACCIONES DE JUEGO Y OVERLAYS
    // ==========================================
    const triggerSpin = async (targetId) => {
        showMessage('Enviando giro...', MESSAGE_TYPE.INFO);
        const configToUse = targetId === 1 ? mainConfig : standConfig;
        const result = await BLSpinMachine(configToUse);
        if (result.success) {
            if(result.data?.result?.isWinner) showMessage('¡GANADOR! 🎉', MESSAGE_TYPE.SUCCESS);
            else showMessage('Perdedor ❌', MESSAGE_TYPE.WARNING);
        } else showMessage(result.message, MESSAGE_TYPE.ERROR);
    };

    const triggerPrepare = async (targetId) => {
        showMessage('Reiniciando máquina...', MESSAGE_TYPE.INFO);
        const result = await BLPrepareMachine(targetId);
        if (result.success) {
            showMessage('Lista para jugar', MESSAGE_TYPE.SUCCESS);
            setThanksStates(prev => ({ ...prev, [targetId]: false }));
        }
        else showMessage(result.message, MESSAGE_TYPE.ERROR);
    };

    const toggleThanksForScreen = async (targetId) => {
        const currentState = thanksStates[targetId] || false;
        const newState = !currentState;
        
        setIsLoading(true);
        showMessage('Enviando instrucción...', MESSAGE_TYPE.INFO);
        const result = await BLToggleThanks(targetId, newState);
        
        if(result.success){
            setThanksStates(prev => ({ ...prev, [targetId]: newState }));
            showMessage(`Agradecimiento ${newState ? 'Mostrado' : 'Oculto'}`, MESSAGE_TYPE.SUCCESS);
        } else {
            showMessage(result.message, MESSAGE_TYPE.ERROR);
        }
        setIsLoading(false);
    };

    const confirmApplyToAll = (field, value, fieldName) => {
        setConfirmConfig({
            message: `¿Deseas aplicar el valor de ${fieldName} a TODAS las pantallas extra (Stands)?`,
            action: async () => {
                showMessage('Aplicando a todas...', MESSAGE_TYPE.INFO);
                const stands = screensList.filter(s => s.id !== 1);
                for(let stand of stands) {
                    await BLSaveMachineConfig({ targetScreenId: stand.id, [field]: value });
                }
                showMessage('✅ Aplicado a todas las pantallas', MESSAGE_TYPE.SUCCESS);
                return { success: true };
            },
            textYes: 'Sí, Aplicar a todas',
            textNo: 'Cancelar'
        });
        setShowConfirmModal(true);
    };

    const ReturnToDashboard = async () => { await BLResetCurrentDynamic(); getOutOfTheDynamic(); };

    // ==========================================
    // RENDERIZADO DE REGLAS
    // ==========================================
    const renderRulesEditor = (isMain) => {
        const conf = isMain ? mainConfig : standConfig;
        const updateFn = isMain ? updateMainConfig : updateStandConfig;
        const showProb = isMain ? showCustomMainProb : showCustomStandProb;
        const setShowProb = isMain ? setShowCustomMainProb : setShowCustomStandProb;
        const showTimes = isMain ? showCustomMainTimes : showCustomStandTimes;
        const setShowTimes = isMain ? setShowCustomMainTimes : setShowCustomStandTimes;
        const prefix = isMain ? 'main' : 'stand';

        return (
            <div className="bg-white p-3 rounded-4 border shadow-sm">
                {/* PROBABILIDAD */}
                <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="fw-bold m-0 text-dark">Probabilidad de que ganen</label>
                        <button className="btn btn-link text-secondary btn-sm p-0 text-decoration-none" onClick={() => setShowProb(!showProb)}>
                            <i className={`bi ${showProb ? 'bi-eye-slash' : 'bi-sliders'}`}></i> {showProb ? 'Ocultar' : 'Personalizar'}
                        </button>
                    </div>
                    
                    <div className="d-flex gap-2 mb-2 flex-wrap">
                        <button className={`btn btn-sm ${conf.winProbability === 0 ? 'btn-danger fw-bold' : 'btn-outline-danger'}`} onClick={() => updateFn('winProbability', 0)}>Nunca (0%)</button>
                        <button className={`btn btn-sm ${conf.winProbability === 30 ? 'btn-warning fw-bold text-dark' : 'btn-outline-warning text-dark'}`} onClick={() => updateFn('winProbability', 30)}>Difícil (30%)</button>
                        <button className={`btn btn-sm ${conf.winProbability === 50 ? 'btn-primary fw-bold' : 'btn-outline-primary'}`} onClick={() => updateFn('winProbability', 50)}>50/50 (50%)</button>
                        <button className={`btn btn-sm ${conf.winProbability === 100 ? 'btn-success fw-bold' : 'btn-outline-success'}`} onClick={() => updateFn('winProbability', 100)}>Siempre (100%)</button>
                        
                        {!isMain && (
                            <button className="btn btn-sm btn-outline-secondary ms-auto mt-3" onClick={() => confirmApplyToAll('winProbability', conf.winProbability, 'Probabilidad')} title="Copiar a los demás stands">
                                <i className="bi bi-copy"></i> Aplicar a todos los stands
                            </button>
                        )}
                    </div>

                    {showProb && (
                        <div className="input-group input-group-sm w-50 mt-2">
                            <input type="number" className="form-control fw-bold" placeholder="Ej: 75" value={tempInputs[`${prefix}_prob`] || ''} onChange={(e) => handleTempInputChange(`${prefix}_prob`, e.target.value)} onKeyDown={(e) => handleKeyDown(e, isMain, 'winProbability', `${prefix}_prob`)} />
                            <span className="input-group-text bg-light">%</span>
                            <button className="btn btn-primary" onClick={() => applyCustomValue(isMain, 'winProbability', `${prefix}_prob`)}>Aplicar</button>
                        </div>
                    )}
                </div>

                <hr className="text-muted opacity-25" />

                {/* TIEMPOS */}
                <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <label className="fw-bold m-0 text-dark">Velocidades de la máquina</label>
                        <button className="btn btn-link text-secondary btn-sm p-0 text-decoration-none" onClick={() => setShowTimes(!showTimes)}>
                            <i className={`bi ${showTimes ? 'bi-eye-slash' : 'bi-sliders'}`}></i> {showTimes ? 'Ocultar' : 'Personalizar'}
                        </button>
                    </div>

                    <div className="row g-3">
                        <div className="col-md-12">
                            <span className="small text-muted mb-1 d-block">Velocidad del giro:</span>
                            <div className="d-flex gap-1 mb-2">
                                <button className={`btn btn-sm ${conf.baseTimeMs === 3500 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('baseTimeMs', 3500)}>Lento</button>
                                <button className={`btn btn-sm ${conf.baseTimeMs === 2200 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('baseTimeMs', 2200)}>Normal</button>
                                <button className={`btn btn-sm ${conf.baseTimeMs === 1500 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('baseTimeMs', 1500)}>Rápido</button>
                            </div>
                            {showTimes && (
                                <div className="input-group input-group-sm mt-1">
                                    <input type="number" className="form-control" placeholder="ms" value={tempInputs[`${prefix}_base`] || ''} onChange={(e) => handleTempInputChange(`${prefix}_base`, e.target.value)} onKeyDown={(e) => handleKeyDown(e, isMain, 'baseTimeMs', `${prefix}_base`)}/>
                                    <button className="btn btn-primary" onClick={() => applyCustomValue(isMain, 'baseTimeMs', `${prefix}_base`)}>Aplicar</button>
                                </div>
                            )}
                            <p className='small text-muted mb-0'>Recomendado: Lento</p>
                        </div>
                        <div className="col-md-12">
                            <span className="small text-muted mb-1 d-block">Tiempo de celebración (si gana):</span>
                            <div className="d-flex gap-1 mb-2">
                                <button className={`btn btn-sm ${conf.celebrationTimeMs === 3000 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('celebrationTimeMs', 3000)}>Corto</button>
                                <button className={`btn btn-sm ${conf.celebrationTimeMs === 6000 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('celebrationTimeMs', 6000)}>Normal</button>
                                <button className={`btn btn-sm ${conf.celebrationTimeMs === 10000 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('celebrationTimeMs', 10000)}>Prolongado</button>
                            </div>
                            {showTimes && (
                                <div className="input-group input-group-sm mt-1">
                                    <input type="number" className="form-control" placeholder="ms" value={tempInputs[`${prefix}_celeb`] || ''} onChange={(e) => handleTempInputChange(`${prefix}_celeb`, e.target.value)} onKeyDown={(e) => handleKeyDown(e, isMain, 'celebrationTimeMs', `${prefix}_celeb`)}/>
                                    <button className="btn btn-primary" onClick={() => applyCustomValue(isMain, 'celebrationTimeMs', `${prefix}_celeb`)}>Aplicar</button>
                                </div>
                            )}
                            <p className='small text-muted mb-0'>Recomendado: Corto</p>
                        </div>
                    </div>
                </div>

                <hr className="text-muted opacity-25" />

                {/* ESCALA (ACTUALIZADA CON BOTONES) */}
                {/* <div>
                    <label className="fw-bold m-0 text-dark d-block mb-2">Tamaño de la Máquina (Zoom)</label>
                    <div className="d-flex align-items-center gap-2">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => updateFn('scale', Math.max(50, conf.scale - 10))} title="Reducir tamaño"><i className="bi bi-dash-lg"></i></button>
                        
                        <input type="range" className="form-range flex-grow-1" min="50" max="150" step="10" value={conf.scale} onChange={(e) => updateFn('scale', Number(e.target.value))} />
                        
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => updateFn('scale', Math.min(150, conf.scale + 10))} title="Aumentar tamaño"><i className="bi bi-plus-lg"></i></button>
                        
                        <span className="badge bg-light text-dark border ms-2 px-3 py-2 fs-6">{conf.scale}%</span>
                    </div>
                    <p className='small text-muted mt-2 mb-0'><i className="bi bi-info-circle"></i> Haz clic en "Reiniciar tragamonedas" para aplicar el nuevo tamaño en la pantalla.</p>
                </div> */}

                {/* ESCALA (ACTUALIZADA CON BOTONES) */}
                <div>
                    <label className="fw-bold m-0 text-dark d-block mb-2">Tamaño de la Máquina (Zoom)</label>
                    <div className="d-flex align-items-center gap-2">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => updateFn('scale', Math.max(50, conf.scale - 10))} title="Reducir tamaño"><i className="bi bi-dash-lg"></i></button>
                        <input type="range" className="form-range flex-grow-1" min="50" max="150" step="10" value={conf.scale} onChange={(e) => updateFn('scale', Number(e.target.value))} />
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => updateFn('scale', Math.min(150, conf.scale + 10))} title="Aumentar tamaño"><i className="bi bi-plus-lg"></i></button>
                        <span className="badge bg-light text-dark border ms-2 px-3 py-2 fs-6">{conf.scale}%</span>
                    </div>
                    {/* BOTÓN EXPLÍCITO DE ACTUALIZAR TAMAÑO */}
                    <button className="btn btn-outline-primary btn-sm mt-3 fw-bold" onClick={() => triggerPrepare(isMain ? 1 : selectedStandId)}>
                        <i className="bi bi-arrows-fullscreen"></i> Aplicar nuevo tamaño en la pantalla
                    </button>
                </div>
            </div>
        );
    };

    // Helper para saber si el estadio está online
    const mainScreenObj = screensList.find(s => s.id === 1);
    const isMainOnline = mainScreenObj?.isOnline === true; // Default false si no viene el dato

    return (
        <SecondaryBase actionToExecute={ReturnToDashboard}>
            
            {showConfirmModal && (
                <Confirm message={confirmConfig.message} actionToYesButton={confirmConfig.action} textYesButton={confirmConfig.textYes} textNoButton={confirmConfig.textNo} setShowModal={setShowConfirmModal} />
            )}

            {showQRModal && (
                <>
                    <div className="cModal__Background" onClick={() => setShowQRModal(false)}></div>
                    <div className="cModal__Container" style={{ zIndex: 1050 }}>
                        <div className="cModal__Container__Content position-relative p-0" style={{ background: 'transparent', boxShadow: 'none' }}>
                            <button type="button" className="btn-close position-absolute top-0 end-0 m-3 bg-dark p-2 rounded-circle" onClick={() => setShowQRModal(false)} style={{zIndex: 20}}></button>
                            <div className="bg-dark text-white p-3 rounded-top-4 text-center border-bottom border-secondary">
                                <span className="d-block small text-warning mb-1"><i className="bi bi-tv"></i> Abre este link en tu TV o dispositivo de proyección:</span>
                                <span className="fw-bold user-select-all text-break">{tvTargetUrl}</span>
                            </div>
                            <PremiumQR url={qrTargetUrl} title={qrTitle} />
                        </div>
                    </div>
                </>
            )}

            <div className="mb-4 text-center">
                <p className='fs-2'><i className='bi bi-coin'></i> Tragamonedas</p>

                {/* PÍLDORA DE ACTUALIZACIÓN MANUAL */}
                <div className="d-inline-flex align-items-center gap-2 bg-white px-3 py-1 rounded-pill border shadow-sm">
                    <span className="small text-muted">Estado de pantallas actualizado a las: <strong className="text-dark">{lastRefresh}</strong></span>
                    <button className="btn btn-sm btn-light border rounded-circle p-1 d-flex align-items-center justify-content-center" onClick={loadScreensData} title="Refrescar conexiones" style={{width: '28px', height: '28px'}}>
                        <i className="bi bi-arrow-repeat text-primary"></i>
                    </button>
                </div>
            </div>

            {/* BLOQUE 1: ESTADIO (ID 1) */}
            <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden">
                <div 
                    className={`card-header p-3 cursor-pointer d-flex justify-content-between align-items-center ${isMainExpanded ? 'bg-secondary text-white' : 'bg-light text-dark'}`}
                    onClick={() => setIsMainExpanded(!isMainExpanded)}
                >
                    <h5 className="m-0 fw-bold">
                        <i className="bi bi-projector-fill me-2"></i> 🏟️ Pantalla del estadio {isMainOnline ? '🟢' : '🔴'}
                    </h5>
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-success fw-bold border border-secondary" onClick={(e) => { e.stopPropagation(); BLEnterMachine(); showMessage('Proyectada en Estadio', MESSAGE_TYPE.SUCCESS); }}>
                            Proyectar tragamonedas en pantalla
                        </button>
                        <i className={`bi fs-5 ${isMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                    </div>
                </div>

                {!isMainExpanded && (
                    <div className="card-body bg-white d-flex justify-content-between align-items-center border-top">
                        <span className="text-muted fw-bold">Resumen: <span className="text-primary">{mainConfig.winProbability}% Probabilidad</span> | Escala {mainConfig.scale}%</span>
                        <button className="btn btn-outline-primary btn-sm fw-bold" onClick={() => { setIsMainExpanded(true); openQRModal(1, 'global', 'Pantalla Principal'); }}>
                            <i className="bi bi-qr-code"></i> Ver instrucciones de conexión
                        </button>
                    </div>
                )}

                {isMainExpanded && (
                    <div className="card-body bg-light">
                        <div className="row">
                            <div className="col-md-7">{renderRulesEditor(true)}</div>
                            <div className="col-md-5">
                                <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-center">
                                    <h6 className="fw-bold text-muted text-center mb-3">Preparación</h6>
                                    <button className="btn btn-outline-primary fw-bold py-2 border-dashed" onClick={() => openQRModal(1, 'global', 'Pantalla Principal')}><i className="bi bi-qr-code"></i> Ver instrucciones de conexión</button>

                                    <h6 className="fw-bold text-muted text-center mb-3 mt-5">Controles de emergencia</h6>
                                    <div className="d-grid gap-2">
                                        <button className="btn btn-outline-success fw-bold py-2" onClick={() => triggerSpin(1)}><i className="bi bi-play-fill"></i> Accionar palanca</button>
                                        <button className="btn btn-outline-warning text-dark fw-bold py-2" onClick={() => triggerPrepare(1)}><i className="bi bi-arrow-clockwise"></i> Reiniciar tragamonedas</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* BLOQUE 2: STANDS EXTRA */}
            <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden">
                <div 
                    className={`card-header p-3 cursor-pointer d-flex justify-content-between align-items-center ${isStandsExpanded ? 'bg-secondary text-white' : 'bg-light text-dark'}`}
                    onClick={() => setIsStandsExpanded(!isStandsExpanded)}
                >
                    <h5 className="m-0 fw-bold"><i className="bi bi-tv-fill me-2"></i> 📺 ¿Llevarás el juego a más pantallas? (Stands)</h5>
                    <i className={`bi fs-5 ${isStandsExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                </div>

                {isStandsExpanded && (
                    <div className="card-body bg-light">
                        <div className="d-flex align-items-center mb-4 bg-white p-3 rounded border shadow-sm">
                            <label className="me-3 fw-bold text-dark mb-0">Selecciona el stand:</label>
                            <select className="form-select fw-bold border-1 text-primary shadow-sm w-auto me-3" value={selectedStandId} onChange={handleStandChange}>
                                {screensList.filter(s => s.id !== 1).length === 0 && <option value="0">-- No hay stands --</option>}
                                {/* APLICAMOS EL SEMÁFORO EN LA LISTA DESPLEGABLE */}
                                {screensList.filter(s => s.id !== 1).map(s => (
                                    <option key={s.id} value={s.id}>
                                        {s.isOnline === true ? '🟢' : '🔴'} {s.name}
                                    </option>
                                ))}
                            </select>
                            
                            <button className="btn btn-dark btn-sm fw-bold me-2" onClick={handleAddScreen}>
                                <i className="bi bi-plus-lg"></i> Crear nuevo stand
                            </button>

                            {selectedStandId !== 0 && (
                                <button className="btn btn-outline-danger btn-sm ms-auto fw-bold" onClick={confirmDeleteScreen} title="Eliminar este stand">
                                    <i className="bi bi-trash-fill"></i> Eliminar stand
                                </button>
                            )}
                        </div>

                        {selectedStandId !== 0 ? (
                            <div className="row">
                                <div className="col-md-7">{renderRulesEditor(false)}</div>
                                <div className="col-md-5">
                                    <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-center">
                                        <h6 className="fw-bold text-muted text-center">Preparación</h6>
                                        <button className="btn btn-outline-primary fw-bold py-2" onClick={() => { const stand = screensList.find(s => s.id === selectedStandId); openQRModal(stand.id, stand.connectionToken, stand.name); }}>
                                            <i className="bi bi-qr-code"></i> Ver instrucciones de conexión
                                        </button>

                                        <h6 className="fw-bold text-muted text-center mb-3 mt-5">Controles de emergencia del stand</h6>
                                        <div className="d-grid gap-2">
                                            <button className="btn btn-outline-success fw-bold py-2" onClick={() => triggerSpin(selectedStandId)}><i className="bi bi-play-fill"></i> Accionar palanca</button>    
                                            <button className="btn btn-outline-warning text-dark fw-bold py-2" onClick={() => triggerPrepare(selectedStandId)}><i className="bi bi-arrow-clockwise"></i> Reiniciar tragamonedas</button>
                                        </div>

                                        <h6 className="fw-bold text-muted text-center mt-5">Controles del stand</h6>
                                        <button className={`btn ${thanksStates[selectedStandId] ? 'btn-danger' : 'btn-outline-info text-dark'} fw-bold py-2`} onClick={() => toggleThanksForScreen(selectedStandId)}>
                                            <i className={`bi ${thanksStates[selectedStandId] ? 'bi-eye-slash' : 'bi-chat-square-heart'}`}></i> {thanksStates[selectedStandId] ? 'Quitar agradecimiento' : 'Mostrar agradecimiento'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center p-4 text-muted">Crea un nuevo stand para configurar sus reglas.</div>
                        )}
                    </div>
                )}
            </div>

            {/* BOTÓN GLOBAL DE IDENTIFICACIÓN */}
            <div className="text-center mt-4">
                <button className="btn btn-outline-dark fw-bold shadow-sm" onClick={() => { BLIdentifyAllScreens(); showMessage('Enviando señal a las pantallas...', MESSAGE_TYPE.INFO); }}>
                    <i className="bi bi-search"></i> Identificar todas las pantallas físicas
                </button>
                <p className='small text-muted mt-2'>Útil si tienes varias pantallas conectadas y no sabes cuál es cuál.</p>
            </div>

        </SecondaryBase>
    );
};

export { SlotMachine };









// import { useEffect, useState } from 'react'
// import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'

// import { SecondaryBase } from './../Commons/SecondaryBase'
// import { Confirm } from './../../Commons/Modals/Confirm'

// import { ResetCurrentDynamic as BLResetCurrentDynamic } from './../../../utilities/BL/Zones'
// import { 
//     PrepareMachine as BLPrepareMachine, 
//     SpinMachine as BLSpinMachine,
//     ToggleQR as BLToggleQR,
//     ToggleThanks as BLToggleThanks,
//     EnterMachine as BLEnterMachine,
//     GetMachineConfig as BLGetMachineConfig,
//     SaveMachineConfig as BLSaveMachineConfig,
//     GetActiveScreens as BLGetActiveScreens,
//     CreateMachineScreen as BLCreateMachineScreen,
//     DeleteMachineScreen as BLDeleteMachineScreen,
//     IdentifyAllScreens as BLIdentifyAllScreens
// } from './../../../utilities/BL/SlotMachine'

// import { PremiumQR } from './../../Commons/PremiumQR'


// const SlotMachine = ({ getOutOfTheDynamic }) => {
//     const { showMessage } = useFloatMessage();
//     const [isLoading, setIsLoading] = useState(false);

//     const [screensList, setScreensList] = useState([]);
    
//     // Control de Acordeones
//     const [isMainExpanded, setIsMainExpanded] = useState(true);
//     const [isStandsExpanded, setIsStandsExpanded] = useState(false);

//     // Modales
//     const [showConfirmModal, setShowConfirmModal] = useState(false);
//     const [confirmConfig, setConfirmConfig] = useState({ message: '', action: null, textYes: '', textNo: 'Cancelar' });
//     const [showQRModal, setShowQRModal] = useState(false);
//     const [qrTargetUrl, setQrTargetUrl] = useState('');
//     const [tvTargetUrl, setTvTargetUrl] = useState('');
//     const [qrTitle, setQrTitle] = useState('');

//     // --- NUEVO ESTADO: Memoria independiente para los botones de Agradecimiento ---
//     const [thanksStates, setThanksStates] = useState({});

//     // Configuración Estadio (ID 1 Fijo)
//     const [mainConfig, setMainConfig] = useState({ targetScreenId: 1, winProbability: 30, baseTimeMs: 2200, celebrationTimeMs: 6000, scale: 100 });
//     const [showCustomMainProb, setShowCustomMainProb] = useState(false);
//     const [showCustomMainTimes, setShowCustomMainTimes] = useState(false);

//     // Configuración Stands (ID > 1)
//     const [selectedStandId, setSelectedStandId] = useState(0);
//     const [standConfig, setStandConfig] = useState({ targetScreenId: 0, winProbability: 30, baseTimeMs: 2200, celebrationTimeMs: 6000, scale: 100 });
//     const [showCustomStandProb, setShowCustomStandProb] = useState(false);
//     const [showCustomStandTimes, setShowCustomStandTimes] = useState(false);

//     const [tempInputs, setTempInputs] = useState({});

//     useEffect(() => {
//         loadScreensData();
//     }, []);

//     const loadScreensData = async () => {
//         const result = await BLGetActiveScreens();
//         if (result.success && result.data) {
//             setScreensList(result.data);
            
//             const mainResult = await BLGetMachineConfig(1);
//             if (mainResult.success && mainResult.data) setMainConfig({ ...mainResult.data, scale: mainResult.data.scale || 100 });

//             const stands = result.data.filter(s => s.id !== 1);
//             if (stands.length > 0) {
//                 setSelectedStandId(stands[0].id);
//                 loadConfigForStand(stands[0].id);
//             }
//         }
//     };

//     const loadConfigForStand = async (standId) => {
//         if (!standId || standId === 0) return;
//         const result = await BLGetMachineConfig(standId);
//         if (result.success && result.data) {
//             setStandConfig({ ...result.data, scale: result.data.scale || 100 });
//         }
//     };

//     const handleStandChange = (e) => {
//         const id = Number(e.target.value);
//         setSelectedStandId(id);
//         loadConfigForStand(id);
//     };

//     // ==========================================
//     // AUTO-GUARDADO
//     // ==========================================
//     const autoSaveConfig = async (newConfig) => {
//         showMessage('Enviando...', MESSAGE_TYPE.INFO);
//         const result = await BLSaveMachineConfig(newConfig);
//         if(result.success) {
//             showMessage('✅ Reglas actualizadas', MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage('Error al guardar', MESSAGE_TYPE.ERROR);
//         }
//     };

//     const updateMainConfig = (field, value) => {
//         const updated = { ...mainConfig, [field]: value };
//         setMainConfig(updated);
//         autoSaveConfig(updated);
//     };

//     const updateStandConfig = (field, value) => {
//         if(selectedStandId === 0) return;
//         const updated = { ...standConfig, [field]: value };
//         setStandConfig(updated);
//         autoSaveConfig(updated);
//     };

//     const handleTempInputChange = (key, value) => setTempInputs(prev => ({ ...prev, [key]: value }));
//     const applyCustomValue = (isMain, field, key) => {
//         const val = Number(tempInputs[key]);
//         if (!isNaN(val)) {
//             if (isMain) updateMainConfig(field, val);
//             else updateStandConfig(field, val);
//         }
//     };
//     const handleKeyDown = (e, isMain, field, key) => { if (e.key === 'Enter') applyCustomValue(isMain, field, key); };

//     // ==========================================
//     // ACCIONES DE PANTALLAS
//     // ==========================================
//     const handleAddScreen = async () => {
//         const screenName = window.prompt("Escribe el nombre de la nueva pantalla (Ej: Stand VIP, Entrada Norte):");
//         if (!screenName || screenName.trim() === '') return;
//         setIsLoading(true);
//         showMessage('Creando pantalla...', MESSAGE_TYPE.INFO);
        
//         const result = await BLCreateMachineScreen(screenName.trim());
//         if (result.success) {
//             const newScreenId = result.data.id;
            
//             // MAGIA AQUÍ: Tomamos los símbolos de la pantalla principal. 
//             // Si por alguna razón no hay, usamos los de por defecto.
//             const inheritedSymbols = (mainConfig.symbols && mainConfig.symbols.length > 0) 
//                 ? mainConfig.symbols 
//                 : ['1.png', '2.png', '3.png', '4.png', '5.png'];

//             // Forzamos el guardado de una configuración por defecto heredando las imágenes
//             await BLSaveMachineConfig({
//                 targetScreenId: newScreenId,
//                 winProbability: 30, // 30% por defecto
//                 baseTimeMs: 2200,
//                 celebrationTimeMs: 6000,
//                 scale: 100,
//                 symbols: inheritedSymbols // <--- APLICAMOS LA HERENCIA AQUÍ
//             });

//             showMessage(`¡Pantalla "${screenName}" creada! Mostrando enlaces...`, MESSAGE_TYPE.SUCCESS);
//             await loadScreensData();
//             setIsStandsExpanded(true);
//             setSelectedStandId(newScreenId);
//             loadConfigForStand(newScreenId);
//             openQRModal(newScreenId, result.data.connectionToken, result.data.name);
//         } else {
//             showMessage(result.message, MESSAGE_TYPE.ERROR);
//         }
//         setIsLoading(false);
//     };

//     const confirmDeleteScreen = () => {
//         const stand = screensList.find(s => s.id === selectedStandId);
//         setConfirmConfig({
//             message: `¿Estás seguro de eliminar el "${stand?.name}"? Esta acción desconectará la pantalla.`,
//             action: async () => {
//                 showMessage('Eliminando...', MESSAGE_TYPE.INFO);
//                 const res = await BLDeleteMachineScreen(selectedStandId);
//                 if(res.success){
//                     showMessage('Pantalla eliminada', MESSAGE_TYPE.SUCCESS);
//                     loadScreensData();
//                 } else showMessage(res.message, MESSAGE_TYPE.ERROR);
//                 return res;
//             },
//             textYes: 'Sí, Eliminar',
//             textNo: 'Cancelar'
//         });
//         setShowConfirmModal(true);
//     };

//     const openQRModal = (screenId, token, name) => {
//         const tvUrl = (screenId === 1 || screenId === 0) 
//             ? `${window.location.origin}/screen` 
//             : `${window.location.origin}/pantalla-stand/${screenId}`;
//         setTvTargetUrl(tvUrl);

//         const finalScreenId = screenId === 0 ? 1 : screenId;
//         const playerUrl = `${window.location.origin}/slot?screenId=${finalScreenId}`;
//         setQrTargetUrl(playerUrl);

//         setQrTitle(`Unirse a: ${name}`);
//         setShowQRModal(true);
//     };

//     // ==========================================
//     // ACCIONES DE JUEGO Y OVERLAYS
//     // ==========================================
//     const triggerSpin = async (targetId) => {
//         showMessage('Enviando giro...', MESSAGE_TYPE.INFO);
//         const configToUse = targetId === 1 ? mainConfig : standConfig;
//         const result = await BLSpinMachine(configToUse);
//         if (result.success) {
//             if(result.data?.result?.isWinner) showMessage('¡GANADOR! 🎉', MESSAGE_TYPE.SUCCESS);
//             else showMessage('Perdedor ❌', MESSAGE_TYPE.WARNING);
//         } else showMessage(result.message, MESSAGE_TYPE.ERROR);
//     };

//     const triggerPrepare = async (targetId) => {
//         showMessage('Reiniciando máquina...', MESSAGE_TYPE.INFO);
//         const result = await BLPrepareMachine(targetId);
//         if (result.success) {
//             showMessage('Lista para jugar', MESSAGE_TYPE.SUCCESS);
//             // Al reiniciar, apagamos el agradecimiento si estaba prendido
//             setThanksStates(prev => ({ ...prev, [targetId]: false }));
//         }
//         else showMessage(result.message, MESSAGE_TYPE.ERROR);
//     };

//     // CORRECCIÓN 2: Función inteligente para encender/apagar el agradecimiento
//     const toggleThanksForScreen = async (targetId) => {
//         const currentState = thanksStates[targetId] || false;
//         const newState = !currentState;
        
//         setIsLoading(true);
//         showMessage('Enviando instrucción...', MESSAGE_TYPE.INFO);
//         const result = await BLToggleThanks(targetId, newState);
        
//         if(result.success){
//             // Guardamos el nuevo estado en la memoria de este componente
//             setThanksStates(prev => ({ ...prev, [targetId]: newState }));
//             showMessage(`Agradecimiento ${newState ? 'Mostrado' : 'Oculto'}`, MESSAGE_TYPE.SUCCESS);
//         } else {
//             showMessage(result.message, MESSAGE_TYPE.ERROR);
//         }
//         setIsLoading(false);
//     };

//     const confirmApplyToAll = (field, value, fieldName) => {
//         setConfirmConfig({
//             message: `¿Deseas aplicar el valor de ${fieldName} a TODAS las pantallas extra (Stands)?`,
//             action: async () => {
//                 showMessage('Aplicando a todas...', MESSAGE_TYPE.INFO);
//                 const stands = screensList.filter(s => s.id !== 1);
//                 for(let stand of stands) {
//                     await BLSaveMachineConfig({ targetScreenId: stand.id, [field]: value });
//                 }
//                 showMessage('✅ Aplicado a todas las pantallas', MESSAGE_TYPE.SUCCESS);
//                 return { success: true };
//             },
//             textYes: 'Sí, Aplicar a todas',
//             textNo: 'Cancelar'
//         });
//         setShowConfirmModal(true);
//     };

//     const ReturnToDashboard = async () => { await BLResetCurrentDynamic(); getOutOfTheDynamic(); };

//     // ==========================================
//     // RENDERIZADO DE REGLAS
//     // ==========================================
//     const renderRulesEditor = (isMain) => {
//         const conf = isMain ? mainConfig : standConfig;
//         const updateFn = isMain ? updateMainConfig : updateStandConfig;
//         const showProb = isMain ? showCustomMainProb : showCustomStandProb;
//         const setShowProb = isMain ? setShowCustomMainProb : setShowCustomStandProb;
//         const showTimes = isMain ? showCustomMainTimes : showCustomStandTimes;
//         const setShowTimes = isMain ? setShowCustomMainTimes : setShowCustomStandTimes;
//         const prefix = isMain ? 'main' : 'stand';

//         return (
//             <div className="bg-white p-3 rounded-4 border shadow-sm">
//                 {/* PROBABILIDAD */}
//                 <div className="mb-4">
//                     <div className="d-flex justify-content-between align-items-center mb-2">
//                         <label className="fw-bold m-0 text-dark">Probabilidad de que ganen</label>
//                         <button className="btn btn-link text-secondary btn-sm p-0 text-decoration-none" onClick={() => setShowProb(!showProb)}>
//                             <i className={`bi ${showProb ? 'bi-eye-slash' : 'bi-sliders'}`}></i> {showProb ? 'Ocultar' : 'Personalizar'}
//                         </button>
//                     </div>
                    
//                     <div className="d-flex gap-2 mb-2 flex-wrap">
//                         <button className={`btn btn-sm ${conf.winProbability === 0 ? 'btn-danger fw-bold' : 'btn-outline-danger'}`} onClick={() => updateFn('winProbability', 0)}>Nunca (0%)</button>
//                         <button className={`btn btn-sm ${conf.winProbability === 30 ? 'btn-warning fw-bold text-dark' : 'btn-outline-warning text-dark'}`} onClick={() => updateFn('winProbability', 30)}>Difícil (30%)</button>
//                         <button className={`btn btn-sm ${conf.winProbability === 50 ? 'btn-primary fw-bold' : 'btn-outline-primary'}`} onClick={() => updateFn('winProbability', 50)}>50/50 (50%)</button>
//                         <button className={`btn btn-sm ${conf.winProbability === 100 ? 'btn-success fw-bold' : 'btn-outline-success'}`} onClick={() => updateFn('winProbability', 100)}>Siempre (100%)</button>
                        
//                         {!isMain && (
//                             <button className="btn btn-sm btn-outline-secondary ms-auto mt-3" onClick={() => confirmApplyToAll('winProbability', conf.winProbability, 'Probabilidad')} title="Copiar a los demás stands">
//                                 <i className="bi bi-copy"></i> Aplicar a todos los stands
//                             </button>
//                         )}
//                     </div>

//                     {showProb && (
//                         <div className="input-group input-group-sm w-50 mt-2">
//                             <input type="number" className="form-control fw-bold" placeholder="Ej: 75" value={tempInputs[`${prefix}_prob`] || ''} onChange={(e) => handleTempInputChange(`${prefix}_prob`, e.target.value)} onKeyDown={(e) => handleKeyDown(e, isMain, 'winProbability', `${prefix}_prob`)} />
//                             <span className="input-group-text bg-light">%</span>
//                             <button className="btn btn-primary" onClick={() => applyCustomValue(isMain, 'winProbability', `${prefix}_prob`)}>Aplicar</button>
//                         </div>
//                     )}
//                 </div>

//                 <hr className="text-muted opacity-25" />

//                 {/* TIEMPOS */}
//                 <div className="mb-4">
//                     <div className="d-flex justify-content-between align-items-center mb-2">
//                         <label className="fw-bold m-0 text-dark">Velocidades de la máquina</label>
//                         <button className="btn btn-link text-secondary btn-sm p-0 text-decoration-none" onClick={() => setShowTimes(!showTimes)}>
//                             <i className={`bi ${showTimes ? 'bi-eye-slash' : 'bi-sliders'}`}></i> {showTimes ? 'Ocultar' : 'Personalizar'}
//                         </button>
//                     </div>

//                     <div className="row g-3">
//                         <div className="col-md-12"> {/* col-md-6 */}
//                             <span className="small text-muted mb-1 d-block">Velocidad del giro:</span>
//                             <div className="d-flex gap-1 mb-2">
//                                 <button className={`btn btn-sm ${conf.baseTimeMs === 3500 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('baseTimeMs', 3500)}>Lento</button>
//                                 <button className={`btn btn-sm ${conf.baseTimeMs === 2200 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('baseTimeMs', 2200)}>Normal</button>
//                                 <button className={`btn btn-sm ${conf.baseTimeMs === 1500 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('baseTimeMs', 1500)}>Rápido</button>
//                             </div>
//                             {showTimes && (
//                                 <div className="input-group input-group-sm mt-1">
//                                     <input type="number" className="form-control" placeholder="ms" value={tempInputs[`${prefix}_base`] || ''} onChange={(e) => handleTempInputChange(`${prefix}_base`, e.target.value)} onKeyDown={(e) => handleKeyDown(e, isMain, 'baseTimeMs', `${prefix}_base`)}/>
//                                     <button className="btn btn-primary" onClick={() => applyCustomValue(isMain, 'baseTimeMs', `${prefix}_base`)}>Aplicar</button>
//                                 </div>
//                             )}
//                             <p className='small text-muted mb-0'>Recomendado: Lento</p>
//                         </div>
//                         <div className="col-md-12"> {/* col-md-6 */}
//                             <span className="small text-muted mb-1 d-block">Tiempo de celebración (si gana):</span>
//                             <div className="d-flex gap-1 mb-2">
//                                 <button className={`btn btn-sm ${conf.celebrationTimeMs === 3000 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('celebrationTimeMs', 3000)}>Corto</button>
//                                 <button className={`btn btn-sm ${conf.celebrationTimeMs === 6000 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('celebrationTimeMs', 6000)}>Normal</button>
//                                 <button className={`btn btn-sm ${conf.celebrationTimeMs === 10000 ? 'btn-secondary' : 'btn-outline-secondary'}`} onClick={() => updateFn('celebrationTimeMs', 10000)}>Prolongado</button>
//                             </div>
//                             {showTimes && (
//                                 <div className="input-group input-group-sm mt-1">
//                                     <input type="number" className="form-control" placeholder="ms" value={tempInputs[`${prefix}_celeb`] || ''} onChange={(e) => handleTempInputChange(`${prefix}_celeb`, e.target.value)} onKeyDown={(e) => handleKeyDown(e, isMain, 'celebrationTimeMs', `${prefix}_celeb`)}/>
//                                     <button className="btn btn-primary" onClick={() => applyCustomValue(isMain, 'celebrationTimeMs', `${prefix}_celeb`)}>Aplicar</button>
//                                 </div>
//                             )}
//                             <p className='small text-muted mb-0'>Recomendado: Corto</p>
//                         </div>
//                     </div>
//                 </div>

//                 <hr className="text-muted opacity-25" />

//                 {/* ESCALA */}
//                 <div>
//                     <label className="fw-bold m-0 text-dark d-block mb-2">Tamaño de la Máquina (Zoom)</label>
//                     <div className="d-flex align-items-center gap-3">
//                         <i className="bi bi-zoom-out text-muted"></i>
//                         <input type="range" className="form-range" min="50" max="150" step="10" value={conf.scale} onChange={(e) => updateFn('scale', Number(e.target.value))} />
//                         <i className="bi bi-zoom-in text-muted"></i>
//                         <span className="badge bg-light text-dark border">{conf.scale}%</span>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     return (
//         <SecondaryBase actionToExecute={ReturnToDashboard}>
            
//             {showConfirmModal && (
//                 <Confirm message={confirmConfig.message} actionToYesButton={confirmConfig.action} textYesButton={confirmConfig.textYes} textNoButton={confirmConfig.textNo} setShowModal={setShowConfirmModal} />
//             )}

//             {showQRModal && (
//                 <>
//                     <div className="cModal__Background" onClick={() => setShowQRModal(false)}></div>
//                     <div className="cModal__Container" style={{ zIndex: 1050 }}>
//                         <div className="cModal__Container__Content position-relative p-0" style={{ background: 'transparent', boxShadow: 'none' }}>
//                             <button type="button" className="btn-close position-absolute top-0 end-0 m-3 bg-dark p-2 rounded-circle" onClick={() => setShowQRModal(false)} style={{zIndex: 20}}></button>
//                             <div className="bg-dark text-white p-3 rounded-top-4 text-center border-bottom border-secondary">
//                                 <span className="d-block small text-warning mb-1"><i className="bi bi-tv"></i> Abre este link en tu TV o dispositivo de proyección:</span>
//                                 <span className="fw-bold user-select-all text-break">{tvTargetUrl}</span>
//                             </div>
//                             <PremiumQR url={qrTargetUrl} title={qrTitle} />
//                         </div>
//                     </div>
//                 </>
//             )}

//             <div className="mb-4 text-center">
//                 <p className='fs-2'><i className='bi bi-coin'></i> Tragamonedas</p>    
//                 {/* <p className="text-muted">Panel de control asistido para operadores del evento.</p> */}
//             </div>

//             {/* BLOQUE 1: ESTADIO (ID 1) */}
//             <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden">
//                 <div 
//                     className={`card-header p-3 cursor-pointer d-flex justify-content-between align-items-center ${isMainExpanded ? 'bg-secondary text-white' : 'bg-light text-dark'}`}
//                     onClick={() => setIsMainExpanded(!isMainExpanded)}
//                 >
//                     <h5 className="m-0 fw-bold"><i className="bi bi-projector-fill me-2"></i> 🏟️ Pantalla del estadio (o principal)</h5>
//                     <div className="d-flex align-items-center gap-3">
//                         <button className="btn btn-success fw-bold border border-secondary" onClick={(e) => { e.stopPropagation(); BLEnterMachine(); showMessage('Proyectada en Estadio', MESSAGE_TYPE.SUCCESS); }}>
//                             Proyectar tragamonedas en pantalla
//                         </button>
//                         <i className={`bi fs-5 ${isMainExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
//                     </div>
//                 </div>

//                 {!isMainExpanded && (
//                     <div className="card-body bg-white d-flex justify-content-between align-items-center border-top">
//                         <span className="text-muted fw-bold">Resumen: <span className="text-primary">{mainConfig.winProbability}% Probabilidad</span> | Escala {mainConfig.scale}%</span>
//                         <button className="btn btn-outline-primary btn-sm fw-bold" onClick={() => { setIsMainExpanded(true); openQRModal(1, 'global', 'Pantalla Principal'); }}>
//                             <i className="bi bi-qr-code"></i> Ver instrucciones de conexión
//                         </button>
//                     </div>
//                 )}

//                 {isMainExpanded && (
//                     <div className="card-body bg-light">
//                         <div className="row">
//                             <div className="col-md-7">{renderRulesEditor(true)}</div>
//                             <div className="col-md-5">
//                                 <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-center">
//                                     <h6 className="fw-bold text-muted text-center mb-3">Preparación</h6>
//                                     <button className="btn btn-outline-primary fw-bold py-2 border-dashed" onClick={() => openQRModal(1, 'global', 'Pantalla Principal')}><i className="bi bi-qr-code"></i> Ver instrucciones de conexión</button>

//                                     <h6 className="fw-bold text-muted text-center mb-3 mt-5">Controles de emergencia</h6>
//                                     <div className="d-grid gap-2">
//                                         <button className="btn btn-outline-success fw-bold py-2" onClick={() => triggerSpin(1)}><i className="bi bi-play-fill"></i> Accionar palanca</button>
//                                         <button className="btn btn-outline-warning text-dark fw-bold py-2" onClick={() => triggerPrepare(1)}><i className="bi bi-arrow-clockwise"></i> Reiniciar tragamonedas</button>
                                        
//                                         {/* <button className={`btn ${thanksStates[1] ? 'btn-danger' : 'btn-outline-info'} fw-bold py-2 mt-2`} onClick={() => toggleThanksForScreen(1)}>
//                                             <i className={`bi ${thanksStates[1] ? 'bi-eye-slash' : 'bi-stars'}`}></i> {thanksStates[1] ? 'Quitar Agradecimiento' : 'Mostrar Agradecimiento'}
//                                         </button> */}

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* BLOQUE 2: STANDS EXTRA */}
//             <div className="card shadow-sm border-0 mb-4 rounded-4 overflow-hidden">
//                 <div 
//                     className={`card-header p-3 cursor-pointer d-flex justify-content-between align-items-center ${isStandsExpanded ? 'bg-secondary text-white' : 'bg-light text-dark'}`}
//                     onClick={() => setIsStandsExpanded(!isStandsExpanded)}
//                 >
//                     <h5 className="m-0 fw-bold"><i className="bi bi-tv-fill me-2"></i> 📺 ¿Llevarás el juego a más pantallas? (Stands)</h5>
//                     <i className={`bi fs-5 ${isStandsExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
//                 </div>

//                 {isStandsExpanded && (
//                     <div className="card-body bg-light">
//                         <div className="d-flex align-items-center mb-4 bg-white p-3 rounded border shadow-sm">
//                             <label className="me-3 fw-bold text-dark mb-0">Selecciona el stand:</label>
//                             <select className="form-select fw-bold border-1 text-primary shadow-sm w-auto me-3" value={selectedStandId} onChange={handleStandChange}>
//                                 {screensList.filter(s => s.id !== 1).length === 0 && <option value="0">-- No hay stands --</option>}
//                                 {screensList.filter(s => s.id !== 1).map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//                             </select>
                            
//                             <button className="btn btn-dark btn-sm fw-bold me-2" onClick={handleAddScreen}>
//                                 <i className="bi bi-plus-lg"></i> Crear nuevo stand
//                             </button>

//                             {selectedStandId !== 0 && (
//                                 <button className="btn btn-outline-danger btn-sm ms-auto fw-bold" onClick={confirmDeleteScreen} title="Eliminar este stand">
//                                     <i className="bi bi-trash-fill"></i> Eliminar stand
//                                 </button>
//                             )}
//                         </div>

//                         {selectedStandId !== 0 ? (
//                             <div className="row">
//                                 <div className="col-md-7">{renderRulesEditor(false)}</div>
//                                 <div className="col-md-5">
//                                     <div className="bg-white p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-center">
//                                         <h6 className="fw-bold text-muted text-center">Preparación</h6>
//                                         <button className="btn btn-outline-primary fw-bold py-2" onClick={() => { const stand = screensList.find(s => s.id === selectedStandId); openQRModal(stand.id, stand.connectionToken, stand.name); }}>
//                                             <i className="bi bi-qr-code"></i> Ver instrucciones de conexión
//                                         </button>

//                                         <h6 className="fw-bold text-muted text-center mb-3 mt-5">Controles de emergencia del stand</h6>
//                                         <div className="d-grid gap-2">
//                                             <button className="btn btn-outline-success fw-bold py-2" onClick={() => triggerSpin(selectedStandId)}><i className="bi bi-play-fill"></i> Accionar palanca</button>    
//                                             <button className="btn btn-outline-warning text-dark fw-bold py-2" onClick={() => triggerPrepare(selectedStandId)}><i className="bi bi-arrow-clockwise"></i> Reiniciar tragamonedas</button>
//                                         </div>

//                                         <h6 className="fw-bold text-muted text-center mt-5">Controles del stand</h6>
//                                         <button className={`btn ${thanksStates[selectedStandId] ? 'btn-danger' : 'btn-outline-info text-dark'} fw-bold py-2`} onClick={() => toggleThanksForScreen(selectedStandId)}>
//                                             <i className={`bi ${thanksStates[selectedStandId] ? 'bi-eye-slash' : 'bi-chat-square-heart'}`}></i> {thanksStates[selectedStandId] ? 'Quitar agradecimiento' : 'Mostrar agradecimiento'}
//                                         </button>
//                                     </div>
//                                 </div>
//                             </div>
//                         ) : (
//                             <div className="text-center p-4 text-muted">Crea un nuevo stand para configurar sus reglas.</div>
//                         )}
//                     </div>
//                 )}
//             </div>

//             {/* BLOQUE 3: CONTROL MAESTRO */}
//             {/* <div className="card shadow border-danger mb-4 rounded-4">
//                 <div className="card-header bg-danger text-white p-3 text-center">
//                     <h5 className="m-0 fw-bold"><i className="bi bi-exclamation-triangle-fill"></i> Acciones Globales (Todas las Pantallas)</h5>
//                 </div>
//                 <div className="card-body bg-white text-center p-4">
//                     <p className="text-muted mb-4">Usa estos botones con precaución. Afectarán al Estadio y a todos los Stands al mismo tiempo.</p>
//                     <div className="d-flex justify-content-center gap-3 flex-wrap">
//                         <button className="btn btn-outline-dark fw-bold px-4 py-2" onClick={() => { BLIdentifyAllScreens(); showMessage('Flasheando IDs en pantallas', MESSAGE_TYPE.INFO); }}>
//                             <i className="bi bi-search"></i> Identificar Pantallas (Flashear)
//                         </button>
//                         <button className="btn btn-warning fw-bold px-4 py-2 text-dark border-dark" onClick={() => { BLPrepareMachine(0); showMessage('Todas reiniciadas', MESSAGE_TYPE.SUCCESS); }}>
//                             <i className="bi bi-arrow-clockwise"></i> Reiniciar Todas a "LISTO"
//                         </button>
//                         <button className="btn btn-success fw-bold px-4 py-2 border-dark" onClick={() => { BLSpinMachine({targetScreenId: 0}); showMessage('Giro global enviado', MESSAGE_TYPE.INFO); }}>
//                             <i className="bi bi-play-fill"></i> Girar TODAS Simultáneas
//                         </button>
//                         <button className="btn btn-info fw-bold px-4 py-2 text-dark border-dark" onClick={() => { BLToggleThanks(0, true); showMessage('Agradecimiento global mostrado', MESSAGE_TYPE.SUCCESS); }}>
//                             <i className="bi bi-stars"></i> Mostrar Agradecimiento Global
//                         </button>
//                     </div>
//                 </div>
//             </div> */}

//         </SecondaryBase>
//     );
// };

// export { SlotMachine };